import type { SuiteOrganizationV1 } from "@fulcrum5/suite-contracts";
import { useState } from "react";

export interface SuiteOrganizationMarkProps {
  readonly organization: SuiteOrganizationV1 | null;
  /** Shown when there is no active organization (Platform admin workspace). */
  readonly emptyLabel?: string;
  readonly className?: string;
}

function joinClassNames(...classNames: Array<string | undefined>): string {
  return classNames.filter((className): className is string => Boolean(className)).join(" ");
}

/**
 * Compact active-organization identity for suite top bars: logo when set,
 * otherwise the organization name so users can tell which org they are in.
 */
export function SuiteOrganizationMark({
  organization,
  emptyLabel = "Platform administration",
  className,
}: SuiteOrganizationMarkProps): JSX.Element {
  const [logoFailed, setLogoFailed] = useState(false);
  const label = organization?.name ?? emptyLabel;
  const logoUrl = organization?.logoUrl ?? null;
  const showLogo = logoUrl !== null && !logoFailed;

  return (
    <div
      className={joinClassNames("f5-suite-root", "f5-suite-organization-mark", className)}
      data-suite-organization-mark=""
      title={label}
    >
      {showLogo ? (
        <img
          alt={`${label} logo`}
          className="f5-suite-organization-mark__logo"
          onError={() => setLogoFailed(true)}
          src={logoUrl}
        />
      ) : (
        <span className="f5-suite-organization-mark__name">{label}</span>
      )}
    </div>
  );
}
